<template>
  <VDataGridV2
    clickable
    :loader="dataLoader"
    entity-type="productHsCode"
    :context-menu="ProductCodeMappingsService.contextMenu"
    @row:dblclick="openProductCodeMappingCard"
  >
    <VDataGridColumnV2
      id="id"
      label="№"
      width="50px"
      content-align="center"
    >
      <template #default="{ row }">
        <VLink @click="openProductCodeMappingCard(row)">{{ row.id }}</VLink>
      </template>
    </VDataGridColumnV2>
    <VDataGridColumnV2
      id="productCodeKsz"
      label="Код продукта КСЗ"
      width="200px"
      content-align="center"
    >
      <template #default="{ row }">
        {{ row.productCodeKsz }}
      </template>
    </VDataGridColumnV2>
    <VDataGridColumnV2
      id="productCodeNmg"
      label="Код продукта Нмг"
      width="200px"
      content-align="center"
    >
      <template #default="{ row }">
        {{ row.productCodeNmg }}
      </template>
    </VDataGridColumnV2>
    <VDataGridColumnV2
      id="hsCodeRu"
      label="ТН ВЭД РФ"
      width="200px"
      content-align="center"
    >
      <template #default="{ row }">
        {{ row.hsCodeRu }}
      </template>
    </VDataGridColumnV2>
    <VDataGridColumnV2
      id="hsCodeUz"
      label="ТН ВЭД Узбекистана"
      width="200px"
      content-align="center"
    >
      <template #default="{ row }">
        {{ row.hsCodeUz }}
      </template>
    </VDataGridColumnV2>
    <VDataGridActionBarV2>
      <VButton theme="primary" @click="openProductCodeMappingCard">
        Создать связку кодов
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">
import DataGridLoader from "@/lib/components/VDataGridV2/DataGridLoader";
import ProductCodeMappingsService from "@/domains/ProductCodeMappings/ProductCodeMappingsService";
import ProductCodeMapping from "@/domains/ProductCodeMappings/ProductCodeMapping";

export default defineComponent({
  name: 'ProductCodeMappingsRegistry',

  setup() {
    return {
      ProductCodeMappingsService
    }
  },

  data() {
    return {
      dataLoader: new DataGridLoader(ProductCodeMappingsService.getListPaginated.bind(ProductCodeMappingsService))
    }
  },

  methods: {
    async openProductCodeMappingCard(productCodeMapping: ProductCodeMapping|null) {
      await this.$core.dialogs.ProductCodeMappingCard.showAsPromise({ productCodeMapping });
      await this.dataLoader.refresh();
    }
  },
});
</script>
